import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutore-menu',
  templateUrl: './tutore-menu.component.html',
  styleUrls: ['./tutore-menu.component.css']
})
export class TutoreMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
